import Questionnaire from "../sections/Questionnaire";

const icons = [
  {
    title: "Abwasser inkl. WC",
    externalLink: "/hebeanlage/hebeanlage-w/?rng_min_price=1412&rng_max_price=20870",
    //imgUrl: "/content/uploads/2018/08/haus.png"
  },
  {
    title: "Abwasser ohne WC",
    // TODO bsp Dusche
    externalLink: "/hebeanlage/schmutzwasserhebeanlage/?rng_min_pa_foerdermenge-max=9-5&rng_max_pa_foerdermenge-max=14&rng_orderby_pa_foerdermenge-max=number&rng_order_pa_foerdermenge-max=ASC",
    //imgUrl: "/content/uploads/2018/08/loch.png"
  }
]

export function AbwasserHausHaeufig() {

  return (
    <Questionnaire question={"Welche Arten von Abwasser sollen abgeführt werden?"} icons={icons} />
  );
}